import { render } from "./CandidateAvatar.vue?vue&type=template&id=0682c990"
import script from "./CandidateAvatar.vue?vue&type=script&lang=js"
export * from "./CandidateAvatar.vue?vue&type=script&lang=js"
script.render = render

export default script